module.exports = __webpack_public_path__ + "static/media/shape_svg.d5ca2469.svg";